import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  DateInput,
  BooleanInput,
  translate
} from "admin-on-rest";
import RichTextInput from "aor-rich-text-input";
import {validateGameTipData} from "./validations";
import {connect} from "react-redux";
import {formStyle} from "./style";

let DateTimeFormat;
DateTimeFormat = global.Intl.DateTimeFormat;

class GameTipCreateFormBase extends React.Component {
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.speltips) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};

    return (
      <Create {...props} title="resources.gametips.titleCreate">
        <SimpleForm redirect="list" validate={validateGameTipData}>
          <ImageInput
            source="images"
            label="resources.gametips.inputs.articleImage"
            accept="image/*"
          >
            <ImageField source="src" title="title" />
          </ImageInput>
          {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            errors.images && (
              <span style={formStyle.validationStyle}>
                {props.translate("resources.gametips.validation.images")}
              </span>
            )}
          <TextInput label="resources.gametips.inputs.title" source="title" />
          <TextInput label="resources.gametips.inputs.author" source="author" />
          <DateInput
            label="resources.gametips.inputs.date"
            source="date"
            options={{
              minDate: new Date(),
              locale: "sv",
              DateTimeFormat: Intl.DateTimeFormat,
              formatDate: new DateTimeFormat("sv", {
                day: "numeric",
                month: "long",
                year: "numeric"
              }).format
            }}
          />
          <BooleanInput
            label="resources.gametips.inputs.published"
            source="published"
          />
          <RichTextInput source="content" addLabel={false} />
          {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            errors.content && (
              <span style={formStyle.validationStyle}>
                {props.translate("resources.gametips.validation.content")}
              </span>
            )}
        </SimpleForm>
      </Create>
    );
  }
}

const mapStateToProps = state => {
  return {
    errors: state.form[`record-form`],
    configuration: state.configuration
  };
};

const GameTipCreateForm = connect(mapStateToProps)(
  translate(GameTipCreateFormBase)
);

export default GameTipCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/GameTipCreateForm.js